import React from "react";
import { Helmet } from "react-helmet-async";

interface SEOHeadProps {
  title: string;
  description: string;
  canonical?: string;
  ogImage?: string;
  noIndex?: boolean;
  schemaJson?: string;
  exactTitle?: boolean;
}

export const SEOHead: React.FC<SEOHeadProps> = ({
  title,
  description,
  canonical,
  ogImage = "https://assets.cdn.filesafe.space/vyxGSs9NtFYsqksgNt9c/media/6a30a307d64da5ce6b7c3c23.webp",
  noIndex = false,
  schemaJson,
  exactTitle = false,
}) => {
  const siteName = "Pinheiro Advocacia";
  const fullTitle = exactTitle ? title : `${title} | ${siteName}`;

  const baseUrl = "https://advpinheiro.com.br";
  const fullCanonical = canonical
    ? canonical.startsWith("http")
      ? canonical
      : `${baseUrl}${canonical === "/" ? "" : canonical}`
    : undefined;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />

      {noIndex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow" />
      )}

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      {ogImage && <meta property="og:image" content={ogImage} />}
      {fullCanonical && <meta property="og:url" content={fullCanonical} />}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      {ogImage && <meta name="twitter:image" content={ogImage} />}

      {fullCanonical && <link rel="canonical" href={fullCanonical} />}

      {schemaJson && <script type="application/ld+json">{schemaJson}</script>}
    </Helmet>
  );
};
